<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('setCompany');
    this.$store.dispatch('setBrand');
    this.$store.dispatch('setAllUserList');
    this.$store.dispatch('setPaymentCount');
  }
}
</script>


<style>
body{margin:0;}
#app{
  color:rgb(85, 85, 85);
}
a{
  text-decoration:none;
}
</style>
